import { ProgressBarStepModel } from 'models';
import { routes } from 'routes';
import { PaymentTypes } from 'models/Payment';

const DELIVERY_DETAILS_TITLE = 'Delivery details';
const PAYMENT_TITLE = 'Payment';
const FINANCE_APPLICATION_TITLE = 'Finance application';
const SUMMARY_TITLE = 'Summary';
const DEPOSIT_PAYMENT_TITLE = 'Deposit payment';

export class ProgressBarHelper {
    public getCheckoutSteps(currentLocation: string, paymentType: PaymentTypes): ProgressBarStepModel[] {
        if (paymentType === PaymentTypes.None) {
            return [];
        }

        if (paymentType === PaymentTypes.IFC) {
            return this.getFinanceFlowSteps(currentLocation);
        }

        return this.getCardOrPayPalFlowSteps(currentLocation);
    }

    private getFinanceFlowSteps(currentLocation: string) {
        return [
            {
                title: DELIVERY_DETAILS_TITLE,
                isActive: this.isActiveStep(currentLocation, routes.deliveryDetails)
                    || this.isActiveStep(currentLocation, routes.deliveryDate)
            },
            {
                title: FINANCE_APPLICATION_TITLE,
                isActive: this.isActiveStep(currentLocation, routes.dataProtectionNotice)
                    || this.isActiveStep(currentLocation, routes.financeApplication)
                    || this.isActiveStep(currentLocation, routes.financeApplicationStepTwo)
                    || this.isActiveStep(currentLocation, routes.financeApplicationStepThree)
                    || this.isActiveStep(currentLocation, routes.financeApplicationStepFour)
                    || this.isActiveStep(currentLocation, routes.financeApplicationStatusPage)
            },
            {
                title: DEPOSIT_PAYMENT_TITLE,
                isActive: this.isActiveStep(currentLocation, routes.payment)
                || this.isActiveStep(currentLocation, routes.orderPage)
            },
            {
                title: SUMMARY_TITLE,
                isActive: this.isActiveStep(currentLocation, routes.orderSummaryPage)
            }
        ];
    }

    private getCardOrPayPalFlowSteps(currentLocation: string) {
        return [
            {
                title: DELIVERY_DETAILS_TITLE,
                isActive: this.isActiveStep(currentLocation, routes.deliveryDetails)
                    || this.isActiveStep(currentLocation, routes.deliveryDate)
            },
            {
                title: PAYMENT_TITLE,
                isActive: this.isActiveStep(currentLocation, routes.payment)
                    || this.isActiveStep(currentLocation, routes.orderPage)
            },
            {
                title: SUMMARY_TITLE,
                isActive: this.isActiveStep(currentLocation, routes.orderSummaryPage)
            }
        ];
    }

    private isActiveStep(currentLocation: string, stepRoute: { path: string; exact: boolean }): boolean {
        return currentLocation === stepRoute.path;
    }
}

export const progressBarHelper = new ProgressBarHelper();